import { AppState } from 'interactive/hooks/useAppState';
import React from 'react';

interface Props {
    currentValue?: string;
    onChange(name: string): AppState;
    onSubmit(): void;
    hasAnimation: boolean;
}

const NameInput = ({ currentValue, onChange, onSubmit, hasAnimation }: Props) => {
    let className = 'get-started-interactive-content get-started-interactive-content--name-input';

    if (hasAnimation) {
        className = className + ' get-started-interactive-content--with-animation';
    }

    return (
        <div className={className}>
            <div className="get-started-interactive-content__inner">
                <div className="get-started-interactive-content__inner__item">
                    <input
                        type="text"
                        value={currentValue}
                        placeholder="Frank’s Fancy Frankfurts…"
                        onChange={({ target: { value } }) => onChange(value)}
                        className="input-text"
                        onKeyDown={event => (event.key === 'Enter' ? onSubmit() : null)}
                    />
                </div>
            </div>
        </div>
    );
};

export default NameInput;
